<div class="main-container">
    <div class="main-page">
        <div class="prospect-detail">
            <div class="white-card">
                <div class="header-title-row">
                    <div class="header-left">
                        <img src="assets/svg/campaign-icon.svg" alt="Campañas" class="center-svg"/>
                        <h1 class="text-semibold color-org t-24">Campañas</h1>
                        <div class="dropdown-wrapper" #dropdownContainer>
                            <div class="dropdown-trigger" (click)="toggleRecentDropdown()">
                                <span>{{selectedItem === 'recientes' ? 'Campañas de hoy' : 'Todas las campañas'}}</span>
                                <span [class.rotated]="showRecentDropdown">▼</span>
                                <div class="dropdown-menu" [class.show]="showRecentDropdown">
                                    <button class="dropdown-item" [class.selected]="selectedItem === 'todas'" (click)="selectItem('todas')">
                                        <span class="check-icon" *ngIf="selectedItem === 'todas'">✔</span>
                                        Todas las campañas
                                    </button>
                                    <button class="dropdown-item" [class.selected]="selectedItem === 'recientes'" (click)="selectItem('recientes')">
                                        <span class="check-icon" *ngIf="selectedItem === 'recientes'">✔</span>
                                        Campañas de hoy
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="header-actions">
                        <button class="action-btn outline" (click)="openSavedSegments()">
                            <img src="assets/svg/segment-icon.svg" alt="Vista resumen" width="16" height="16" />
                            Segmentos guardados
                        </button>
                        <button class="action-btn primary" (click)="openManageCampana()">
                            <img src="assets/svg/plus-icon.svg" alt="Añadir nuevo" width="16" height="16" />
                            Nueva campaña
                        </button>
                    </div>
                </div>
                <div class="header-stats mt-3">
                    <span>{{campanas.length}} elementos | Se actualizó hace 2 minutos</span>
                    <span *ngIf="hasActiveFilters()" class="filter-badge" style="margin-left: 10px;">
                        Filtros aplicados
                        <button (click)="clearFilters()" class="clear-filters-btn">×</button>
                    </span>
                </div>
                <div class="content-area mt-5">
                    <div *ngIf="errorMessage" class="error-message">
                        {{errorMessage}}
                    </div>
                    <div *ngIf="campanas.length > 0 && !isLoading">
                        <div class="d-grid search-bar-container" style="
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            width: 100%;
                            gap: 16px;
                        ">
                            <div class="npt-table-search-bar d-grid" style="flex: 1; min-width: 0">
                                <div><img src="assets/svg/search.svg" alt=""></div>
                                <input 
                                    type="text" 
                                    class="npt-nav-search" 
                                    placeholder="Buscar por nombre de campaña, segmento o ejecutivo..."
                                    [(ngModel)]="searchTerm"
                                    (input)="onSearchChange()"
                                    style="flex: 1; min-width: 0; width: 100%"
                                >
                            </div>
                            <div style="display: flex; gap: 12px; flex-shrink: 0">
                                <button class="search-btn" (click)="cargarCampanas()" style="display: flex; align-items: center; gap: 6px; white-space: nowrap;">
                                    <img src="assets/svg/reload-icon.svg" alt="Actualizar">
                                    <span>Actualizar</span>
                                </button>
                                <button class="d-grid search-btn">
                                    <img src="assets/svg/pen-icon.svg" alt="Editar">
                                    <span>Editar</span>
                                </button>
                                <button class="search-btn" (click)="openFilterModal()" style="display: flex; align-items: center; gap: 6px; white-space: nowrap;">
                                    <img src="assets/svg/filtrar-icon.svg" alt="Filtrar">
                                    <span>Filtrar</span>
                                </button>
                            </div>
                        </div>
                        <div class="prospectos-table mh-50">
                            <table>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th class="checkbox-column text-center">
                                            <img src="assets/svg/checkline-icon.svg">
                                        </th>
                                        <th>
                                            Nombre de campaña
                                        </th>
                                        <th>
                                            Fecha de inicio
                                        </th>
                                        <th>
                                            Fecha de finalización
                                        </th>
                                        <th>
                                            Segmento destinatario
                                        </th>
                                        <th>
                                            Estado
                                        </th>
                                        <th>
                                            Ejecutivo asignado
                                        </th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let campana of campanas; let i=index" [class.campana-invalida]="!campana.campana_id" (click)="verDetalleCampana(campana.id, $event)">
                                        <td class="counter-cell">{{ i + 1 }}.</td>
                                        <td class="checkbox-column">
                                            <input type="checkbox" (click)="$event.stopPropagation()">
                                        </td>
                                        <td (click)="openCampaignDetail(campana.campana_id)">{{campana.nombre_campana}}</td>
                                        <td>{{campana.fecha_envio | date:'d/mm/y':'':'es'}}</td>
                                        <td>{{campana.fecha_envio | date:'d/mm/y':'':'es'}}</td>
                                        <td (click)="openCampaignSegments(campana.campana_id)">{{campana.segmento.nombre_segmento}}</td>
                                        <td class="estado-cell">
                                            <span class="estado-badge-cmp" [ngClass]="{
                                                'estado-programada': campana.estado?.nombre?.toLowerCase() === 'programada',
                                                'estado-borrador': campana.estado?.nombre?.toLowerCase() === 'borrador',
                                                'estado-enviada': campana.estado?.nombre?.toLowerCase() === 'enviada',
                                                'estado-cancelada': campana.estado?.nombre?.toLowerCase() === 'cancelada'
                                            }">
                                                • {{campana.estado?.nombre || 'Borrador'}}
                                            </span>
                                        </td>
                                        <td>{{campana.segmento.ejecutivo.nombre}} {{campana.segmento.ejecutivo.apellido}}</td>
                                        <td class="actions-cell">
                                            <div class="dropdown-container" (click)="$event.stopPropagation()">
                                                <button class="dots-button" (click)="toggleActionsMenu('menu-' + (campana.campana_id || i))">
                                                    <svg class="dots-icon" viewBox="0 0 24 24">
                                                        <circle cx="12" cy="5" r="2"/>
                                                        <circle cx="12" cy="12" r="2"/>
                                                        <circle cx="12" cy="19" r="2"/>
                                                    </svg>
                                                </button>
                                                <div class="dropdown-menu" [class.show]="openedMenuId === 'menu-' + (campana.campana_id || i)">
                                                    <button class="dropdown-item" (click)="openManageCampana()">Modificar</button>
                                                    <button class="dropdown-item" (click)="deleteCampana(campana.campana_id)">Eliminar</button>
                                                    <button class="dropdown-item" (click)="sendCampana(campana.campana_id)">Enviar</button>
                                                    <button class="dropdown-item" (click)="openRescheduleCampaign()">Reprogramar</button>
                                                    <button class="dropdown-item" (click)="openCampaignChangeStatus(campana.campana_id)">Cambiar estado</button>
                                                    <button class="dropdown-item" (click)="openMdlDeleteCampana(campana.campana_id)">Cambiar propietario</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div *ngIf="campanas.length === 0 && !isLoading" class="empty-state">
                        <div class="empty-content">
                            <div class="empty-image">
                                 <img src="assets/img/listaprospecto.png" alt="Lista de campanas vacía" />
                            </div>
                            <h2>Sin campañas por ahora</h2>
                            <p>Todavía no tienes campañas registradas. Puedes comenzar agregando una nueva.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>        
</div>